import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-product-selection',
  templateUrl: './modal-product-selection.component.html',
  styleUrls: ['./modal-product-selection.component.css']
})
export class ModalProductSelectionComponent {

  constructor(public activeModal: NgbActiveModal) { }

  selectCatalog() {
    this.activeModal.close('catalog');
  }

  selectKnowProduct() {
    this.activeModal.close('know-product');
  }
}
